import { gql, useQuery } from '@apollo/client'
import { Table, Progress, Button, Alert } from 'reactstrap'
import DatetimeRenderer from '../../Material/DatetimeRenderer'


const AllUberAccidentsQuery = gql`query AllUberAccidents($vin: String!, $incidentDate: Date, $limit: Int, $dateAddedCursor: DateTime){
    allUberAccidents(vin: $vin, incidentDate: $incidentDate, limit: $limit, dateAddedCursor: $dateAddedCursor){
        dateAdded
        dateModified
        vehicleSolutions
        uberNumber
        dateReported
        driverName
        period
        carVin
        originState
        incidentDate
        factsOfLoss
        factsOfLossTranslated
        passengerName
        passengerPhone
        passengerEmail
        accidentCircumstances
        claimSubmitted
        carrierName
        claimNumber
        hasNextPage
    } 
}`

export default function RenderUberAccidents({ vin, incidentDate }) {

    const { data: allUberAccidentsData, loading: allUberAccidentsLoading, error: allUberAccidentsError, fetchMore: fetchMoreArgyleGigs } = useQuery(AllUberAccidentsQuery, {
        variables: {
            vin: vin,
            incidentDate: incidentDate ? incidentDate : null,
            limit: 10,
        },
        skip: !vin,
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
    })

    const loadMoreArgyleGigs = () => {
        fetchMoreArgyleGigs({
            variables: {
                dateAddedCursor: allUberAccidentsData?.allUberAccidents[allUberAccidentsData?.allUberAccidents.length - 1].dateAdded,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
                return {
                    allUberAccidents: [...previousResult.allUberAccidents, ...fetchMoreResult.allUberAccidents],
                }
            },
        })
    }

    return (
        <div>
            {allUberAccidentsError && <Alert color="danger">{allUberAccidentsError.message}</Alert>}
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                <Table size="sm" responsive bordered >
                    <thead>
                        <tr>
                            {/* <th>#</th> */}
                            <th>Date Added</th>
                            {/* <th>Date Modified</th> */}
                            {/* <th>Vehicle Solutions</th> */}
                            <th>Uber ID</th>
                            <th>Incident Date</th>
                            <th>Date Reported</th>
                            <th>Driver Name</th>
                            <th>Period</th>
                            {/* <th>Car Vin</th> */}
                            {/* <th>Origin State</th> */}
                            <th>Facts of Loss</th>
                            {/* <th>Facts of Loss Translated</th> */}
                            <th>Passenger Details</th>
                            {/* <th>Passenger Phone</th>
                            <th>Passenger Email</th> */}
                            <th>Accident Circumstances</th>
                            {/* <th>Claim Submitted</th>
                            <th>Carrier Name</th>
                            <th>Claim Number</th> */}
                        </tr>
                        {allUberAccidentsData?.allUberAccidents?.map((uberAccident, i) => (
                            <tr>
                                {/* <td>{i + 1}</td> */}
                                <td><DatetimeRenderer datetime={uberAccident.dateAdded} /></td>
                                {/* <td><DatetimeRenderer datetime={uberAccident.dateModified} /></td> */}
                                {/* <td>{uberAccident.vehicleSolutions}</td> */}
                                <td>{uberAccident.uberNumber}</td>
                                <td>{uberAccident.incidentDate}</td>
                                <td>{uberAccident.dateReported}</td>
                                <td>{uberAccident.driverName}</td>
                                <td>{uberAccident.period}</td>
                                {/* <td>{uberAccident.carVin}</td> */}
                                {/* <td>{uberAccident.originState}</td> */}
                                {/* <td>{uberAccident.factsOfLoss}</td> */}
                                <td>{uberAccident.factsOfLossTranslated}</td>
                                <td>
                                    <i className="fa fa-user" />&nbsp;
                                    {uberAccident.passengerName}
                                    <br />
                                    <i className="fa fa-phone" />&nbsp;
                                    {uberAccident.passengerPhone}
                                    <br />
                                    <i className="fa fa-envelope" />&nbsp;
                                    {uberAccident.passengerEmail}
                                </td>
                                <td>{uberAccident.accidentCircumstances}</td>
                                {/* <td>{uberAccident.claimSubmitted}</td>
                                <td>{uberAccident.carrierName}</td>
                                <td>{uberAccident.claimNumber}</td> */}
                            </tr>
                        ))}
                        <tr>
                            <td colSpan={10} className="text-right">
                                {allUberAccidentsLoading ? <Progress animated value={100} /> :
                                    allUberAccidentsData?.allUberAccidents?.length === 0 ? <p className="text-muted text-center mt-3">No Uber Accidents Found!</p> : allUberAccidentsData?.allUberAccidents?.filter(record => record.hasNextPage).length > 0 && <Button className='primary' size="sm" onClick={loadMoreArgyleGigs} style={{ cursor: "pointer" }}>Load More</Button>
                                }
                            </td>
                        </tr>
                    </thead>
                </Table>
            </div>
        </div>
    )
}